import React from "react"

import PopoverMenuOption from "../../../../../../core/gd-components/popover-menu/popover-menu/menu-option"
import UI5ControlButton from "../../../../../app-controls/buttons/button/button"

const debug = false
// const debug = "SubmenuRequestsAndFormsMenuOption"

type Props = {
    option          : {
        id      : ID
        label   : string
    }

    canEdit         : boolean

    onTogglePin     : {(option:{
            id      : ID
            label   : string
        }):void}

    onEditClick     : {(option:{
            id      : ID
            label   : string
        }):void}

    onPreviewClick  : {(option:{
            id      : ID
            label   : string
        }):void}
}

export default function SubmenuRequestsAndFormsMenuOption(props:Props) {

    const onPinClick = (e: any) => {
        debug && console.log(debug, 'onPinClick', props.option)
        props.onTogglePin(props.option)
    }

    const onPreviewClick = (e: any) => {
        debug && console.log(debug, 'onOptionClick', props.option)
        props.onPreviewClick(props.option)
    }

    const onOptionEdit = (e: any) => {
        debug && console.log(debug, 'onOptionEdit', props.option)
        props.onEditClick(props.option)
    }

    return (
        <PopoverMenuOption option       = {props.option}
                           onClick      = {onPreviewClick}>
            <div className="right">
                <UI5ControlButton className = "m-r-5"
                                  iconClass = "i5-pin"
                                  onClick   = {onPinClick}/>

                <UI5ControlButton className = "m-r-5"
                                  iconClass = "i5-eye"
                                  onClick   = {onPreviewClick}/>

                {props.canEdit &&
                    <UI5ControlButton iconClass = "i5-pen"
                                      onClick   = {onOptionEdit}/>}
            </div>
        </PopoverMenuOption>
    )
}